import { keyboard } from '@testing-library/user-event/dist/keyboard';
import React from 'react';

const About = ({ title, para, img, jlpt,id }) => {
    const JLPTAbout = [
        {
            title: 'JLPT N5',
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability.The test is held twice a year in Japan and selected countries (on the first Sunday of July and December), and once a year in other regions (on the first Sunday of December).The JLPT consists of five levels. To join JLPT classes, enroll now for FREE. "
        },
        {
            title: 'JLPT N4',
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability.The test is held twice a year in Japan and selected countries (on the first Sunday of July and December), and once a year in other regions (on the first Sunday of December).The JLPT consists of five levels. To join JLPT classes, enroll now for FREE. "
        },
        {
            title: 'JLPT N3',
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability.The test is held twice a year in Japan and selected countries (on the first Sunday of July and December), and once a year in other regions (on the first Sunday of December).The JLPT consists of five levels. To join JLPT classes, enroll now for FREE. "
        },
        {
            title: 'JLPT N2',
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability.The test is held twice a year in Japan and selected countries (on the first Sunday of July and December), and once a year in other regions (on the first Sunday of December).The JLPT consists of five levels. To join JLPT classes, enroll now for FREE. "
        },
        {
            title: 'JLPT N1',
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability.The test is held twice a year in Japan and selected countries (on the first Sunday of July and December), and once a year in other regions (on the first Sunday of December).The JLPT consists of five levels. To join JLPT classes, enroll now for FREE. "
        }
    ]
    return (
        <div id={id}>
            <h2 className=' text-2xl lg:text-3xl mt-10 text-slate-400 font-semibold mb-5 border-b-2 border-cyan-500'>{title}</h2>
            <img className=' w-2/3 h-auto lg:h[30vh] mx-auto' src={img} alt="" />
            
            <p className='px-2 text-lg font-medium my-4'>{para}</p>


            {
                jlpt && <div>
                    <div className=''>
                        {
                            JLPTAbout.map((j, index) => <div key={index} className='my-2 grid md:grid-cols-[10%_minmax(90%,_1fr)]'>
                                <h3 className=' text-xl font-bold'>{j.title}</h3>
                                <p>{j.para}</p>
                            </div>)
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export default About;